/* 全局mutation type ，同时负责导出专家与用户专属 mutation type */

export * from './expert/mutation-types.expert';
export * from './user/mutation-types.user';

// socket 事件
export const SOCKET_CONNECT = 'SOCKET_CONNECT'; // 建立连接
export const SOCKET_CONNECT_STATUS = 'SOCKET_CONNECT_STATUS'; // socket 连接状态
export const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT'; // 断开连接
export const SOCKET_SEND_MESSAGE = 'SOCKET_SEND_MESSAGE'; // 发送消息
export const SOCKET_RECEIVE_MESSAGE = 'SOCKET_RECEIVE_MESSAGE'; // 接收消息
export const SOCKET_RECEIVE_MESSAGE_UP = 'SOCKET_RECEIVE_MESSAGE_UP'; // 接收到赞赏消息
export const SOCKET_RECEIVE_MESSAGE_DELETE = 'SOCKET_RECEIVE_MESSAGE_DELETE'; // 接收到删除消息
export const SOCKET_RECEIVE_MESSAGE_LIKE_COUNT = 'SOCKET_RECEIVE_MESSAGE_LIKE_COUNT'; // 接收到点赞消息
export const COURSE_CLOSED = 'COURSE_CLOSED'; // 课程已结束消息

// ajax 事件
export const AJAX_LOADING = 'AJAX_LOADING'; // ajax请求状态
export const AJAX_ERROR = 'AJAX_ERROR'; // ajax 错误处理
export const AJAX_WX_SIGN_STATUS = 'AJAX_WX_SIGN_STATUS'; // 微信签名状态
export const AJAX_GET_SIGNDATA = 'AJAX_GET_SIGNDATA'; // 获取签名信息

export const RESET_MESSAGES = 'RESET_MESSAGES'; // 重置消息
export const RESET_MESSAGE_STORE = 'RESET_MESSAGE_STORE'; // 重置消息队列

// audio 操作
export const AUDIO_LOADSTART = 'AUDIO_LOADSTART'; // 音频开始加载
export const AUDIO_PLAYING = 'AUDIO_PLAYING'; // 音频正在播放
export const AUDIO_STOP = 'AUDIO_STOP'; // 音频正在播放

export const SERIAL_LIST = 'SERIAL_LIST'; // 系列课列表



// WEBPACK FOOTER //
// ./src/store/mutation-types.js